module.exports = __webpack_public_path__ + "img/team-3.118ac645.jpg";